import { render } from "./incomingMaterialStatistics.vue?vue&type=template&id=12f6c334&scoped=true"
import script from "./incomingMaterialStatistics.vue?vue&type=script&lang=js"
export * from "./incomingMaterialStatistics.vue?vue&type=script&lang=js"

import "./incomingMaterialStatistics.vue?vue&type=style&index=0&id=12f6c334&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f6c334"]])

export default __exports__